"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_mail__read__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "3cafe22d-d69a-4d82-bb33-0d39560ed4e8",
    "data-name": "Mail_unread_ic_hi",
    viewBox: "0 0 192 192"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,72l68,42s5.83,4,12,4,12-4,12-4l68-42",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,116c-6.17,0-12-4-12-4L16,70v2l68,42s5.83,4,12,4,12-4,12-4l68-42V70l-68,42S102.17,116,96,116Z",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,118c-6.17,0-12-4-12-4L16,72v80a16,16,0,0,0,16,16H160a16,16,0,0,0,16-16V72l-68,42S102.17,118,96,118Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,166H32a16,16,0,0,1-16-16v2a16,16,0,0,0,16,16H160a16,16,0,0,0,16-16v-2A16,16,0,0,1,160,166Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,72H176V68.46a8,8,0,0,0-3.8-6.81L108,21.5s-5.83-4-12-4-12,4-12,4L19.8,61.66A8,8,0,0,0,16,68.46Z",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,72H176V68.46a8,8,0,0,0-3.8-6.81L108,21.5s-5.83-4-12-4-12,4-12,4L19.8,61.66A8,8,0,0,0,16,68.46Z",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    id: "c473f904-fa41-4ff8-b698-599beef5fba4",
    "data-name": "Bounding Box",
    width: 192,
    height: 192,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("title", null, "mail-read-hi-dark"), /*#__PURE__*/React.createElement("g", {
    id: "1025b894-ce43-410c-9f92-e6d1efccfdb8",
    "data-name": "Mail_read_ic"
  }, /*#__PURE__*/React.createElement("use", {
    id: "91bdcfd5-93b4-48ad-96c5-89c45bcad0af",
    "data-name": "Mail_unread_ic_hi",
    width: 192,
    height: 192,
    transform: "translate(0 0)",
    xlinkHref: "#3cafe22d-d69a-4d82-bb33-0d39560ed4e8"
  })));
}

var _default = ic_mail__read__dark;
exports.default = _default;